import { useEffect, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { getCleanHTML } from 'shared/lib/getCleanHTML.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface RoomDescriptionProps {
  description: string
}

export const RoomDescription = ({ description }: RoomDescriptionProps) => {
  const { t } = useTranslation()
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false)
  const [shouldShowButton, setShouldShowButton] = useState(false)
  const descriptionRef = useRef<HTMLParagraphElement>(null)

  const toggleDescription = () => {
    setIsDescriptionExpanded(!isDescriptionExpanded)
  }

  useEffect(() => {
    const checkLines = () => {
      if (descriptionRef.current) {
        const element = descriptionRef.current

        const lineHeight = parseInt(window.getComputedStyle(element).lineHeight)
        const maxHeight = lineHeight * 2

        setShouldShowButton(element.scrollHeight > maxHeight)
      }
    }

    const timeoutId = setTimeout(checkLines, 0)

    return () => clearTimeout(timeoutId)
  }, [description])

  if (!description) {
    return null
  }

  return (
    <Paper
      padding={[16]}
      radius={16}
      className={s.wrapper}
    >
      <p className={clsx(s.title, 'semi-bold-16')}>
        {t('tours_block.about_room')}
      </p>

      <p
        ref={descriptionRef}
        className={clsx(
          s.description,
          'regular-14',
          !isDescriptionExpanded && s.collapsed,
        )}
        dangerouslySetInnerHTML={{
          __html: getCleanHTML(description, {
            forbiddenTags: ['img'],
          }),
        }}
      />

      {shouldShowButton && (
        <button
          className={clsx('semi-bold-14', s.moreInfo)}
          onClick={toggleDescription}
        >
          <AppIcon
            id={AllIcons.ARROW_BOTTOM}
            width={24}
            height={24}
            className={clsx(s.arrow, isDescriptionExpanded && s.expanded)}
          />
          {isDescriptionExpanded
            ? t('tours_block.hide')
            : t('tours_block.show_all')}
        </button>
      )}
    </Paper>
  )
}
